<template>
    <div class="earningsDoubleLineEchart border-radius5 white mar-bot10">
        <div class="module-header display-flex space-between">
            <div class="module-header-left title">
               {{$t('Yield_curve')}}
            </div>
            <div class="module-header-right">
                <el-select
                        size="small"
                        v-model="month"
                        style="width: 100px"
                >
                    <el-option
                            v-for="(item,index) in monthOptions"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                    ></el-option>
                </el-select>
            </div>
        </div>
        <div class="content">
            <el-row :gutter="20">
                <el-col :lg="16" :md="24" :sm="24" :xs="24">
                    <div class="earning-left pr">
                        <div class="statistics pa">
                            <div class="statistics-left">
                                <span class="text">{{textComputed}}：</span>
                                <div class="left-data">
                                    <div
                                            class="recently"
                                            :class="{
                                'theme-color': isIncludeMinus(statistics.recentlyProfit + ''),
                                'theme-green': !isIncludeMinus(statistics.recentlyProfit + ''),
                                }"
                                    >{{statistics.recentlyProfit}}</div>
                                </div>
                            </div>
                            <div class="statistics-right">
                                <span class="text">{{$t('yesterday')}}：</span>
                                <div class="left-data">
                                    <div
                                            class="recently"
                                            :class="{
                                'theme-color': isIncludeMinus(statistics.todayProfit + ''),
                                'theme-green': !isIncludeMinus(statistics.todayProfit + ''),
                                }"
                                    >{{statistics.todayProfit}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="chart-outer">
                            <div class="no-data-outer"
                                 v-if="traderEarningsDataNullFlag"
                            >
                                {{$t('root.noData')}}
                            </div>
                            <base-chart
                                    ref="traderchart"
                                    :chart-config="earningChartConfig"
                            ></base-chart>
                        </div>
                    </div>
                </el-col>
                <el-col :lg="8" :md="24" :sm="24" :xs="24">
                    <div class="earning-right">
                        <h3 class="title">{{$t('Variety_ranking')}}</h3>
                        <div class="sybol"
                            v-for="(item,index) in symbolList"
                             :key="index"
                             v-if="index <= 4"
                        >
                            <div class="sybol-top display-flex space-between">
                                <span class="font333 blod fs14">{{item.symbol}}</span>
                                <span class="fs14 momey"
                                    :class="{on: isIncludeMinus(item.profit + '') }"
                                >{{item.profit}}</span>
                            </div>
                            <el-tooltip
                                    popper-class="sybol-tooltip"
                                    effect="light"
                                    placement="top"
                            >
                                <div class="" slot="content">
                                    <div class="bear">
                                        <span class="dot"></span>
                                        <span>{{$t('Do_more')}}: {{item.many}}lots</span>
                                    </div>
                                    <div class="more">
                                        <span class="dot"></span>
                                        <span>{{$t('Short')}}: {{item.empty}}lots</span>
                                    </div>
                                </div>
                                <el-progress
                                        :format="format"
                                        :percentage="getPercentageLots(item)"
                                        color="#FF7F5A"
                                ></el-progress>
                            </el-tooltip>
                        </div>
                        <div class="no-data-outer"
                            v-if="!symbolList.length"
                        >
                            {{$t('root.noData')}}
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { queryLoginProfitInfo } from '@/api/copy'

  import { isIncludeMinus,setSufx } from '@/utils/common'
  let echarts = require('echarts');
  import baseChart from '@/components/echarts/baseChart';
  export default {
    name: 'lineChartAndSymbolChart',
    components:{
      baseChart
    },
    data() {
      let _this = this;
      return {
        month: 1,
        monthOptions:[
          {
            label: _this.$t('Nearly_a_month'),
            value: 1,
          },
          {
            label: _this.$t('Nearly_three_months'),
            value: 2,
          },
          {
            label: _this.$t('Nearly_a_year'),
            value: 3,
          },
          {
            label:  _this.$t('All'),
            value: 4,
          },
        ],
        statistics:{
          recentlyProfit: '',
          todayProfit: '$0',
        },
        earningChartConfig: {
          tooltip: {
            trigger: 'axis',
            backgroundColor: "rgba(255,255,255,0.8)",
            borderColor: '#E6E6E6',
            borderWidth: 1,
            boxShadow: "0px 2px 12px 0px rgba(0, 0, 0, 0.06)",
            textStyle: {
              color: "#333333"
            },
            formatter:function(params,ticket,callback) {
              var res='<div><p>'+params[0].name+'</p></div>'

              for(var i=0;i<params.length;i++){
                res+='<p>'+params[i].seriesName+':' +'$'+params[i].data+'</p>'
              }
              if(_this.profitAmountToday.length !== 0){
                res +='<p>'+_this.$t('Today')+':'+ '$'+ +_this.profitAmountToday[params[0].dataIndex]+'</p>'
              }
              return res;
            },
          },
          grid: {
            show: false,
            top:'50px',
            left: '0',
            right: '0',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisTick: {
              show: false
            },
            axisLabel: {
              // formatter: '{value}%',
              color: '',
              fontSize: 14,
              margin: 20
            },
            axisLine: {
              lineStyle: {
                color: 'transparent'
              }
            },
          },
          yAxis: {
            type: 'value',
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: 'transparent'
              }
            },
            //y轴设置为百分比
            axisLabel: {
              formatter: function (value) {
                return '$' + value;
              },
              color: '',
              fontSize: 14,
              margin: 20
            },
            //坐标轴内线的样式
            splitLine: {
              lineStyle: {
                color: 'rgba(233, 233, 233, 1)',
                type:'dashed'
              }
            }
          },
          series: [
            {
              name: _this.$t('Grand_total'),
              type: 'line',
              symbol: 'none',
              smooth: true,
              //  stack 会叠加
              // stack: 'vistors',
              data: [],
              itemStyle: {
                normal: {
                  color: '#11AB7F',
                  lineStyle: {
                    color: '#11AB7F',
                    width: 2
                  },
                },
              },
              /*区域颜色*/
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{        // 1代表上面
                  offset: 0,
                  color: 'rgba(134,203,190,0.5)'
                }, {
                  offset: 1,
                  color: 'rgba(187,231,224,0)'
                }]),

              },
            }
          ]
        },
        // 当日收益
        profitAmountToday: [],
        themeFontColor: '#333333',
        symbolList:[],
      };
    },
    watch:{
      month(newValue){
        if(newValue){
          this.getData();
        }
      }
    },
    computed: {
      traderEarningsDataNullFlag(){
        let flag = false;
        if(!this.earningChartConfig.series[0].data.length){
          flag = true;
        }
        return flag;
      },
      textComputed(){
        switch (this.month) {
          case 1:
            return this.$t('Nearly_a_month');
            break;
          case 2:
            return this.$t('Nearly_three_months');
            break;
          case 3:
            return this.$t('Nearly_a_year');
            break;
          case 4:
            return this.$t('All');
            break;
        }
      },
    },
    mounted(){
      this.getData();
    },
    methods: {
      isIncludeMinus,
      getPercentageLots(item){
        // 做空20,做多50,
        // return 20;
        return (item.many / (item.many + item.empty)) * 100;
      },
      format(){
        return '';
      },
      getData(){
        queryLoginProfitInfo({
          mtId: this.$route.params.mtid,
          timeType: 2,
          timeNumber: this.getTimeNumber(),
        }).then((res) => {
          this.symbolList = res.data.symbolList;
          this.earningChartConfig.xAxis.data = res.data.x;

          this.statistics.recentlyProfit = res.data.totalAmount;
          if(isIncludeMinus(this.statistics.recentlyProfit + '')) {
            this.earningChartConfig.series[0].itemStyle = {
              normal: {
                color: 'rgba(255, 127, 90, 1)',
                lineStyle: {
                  color: 'rgba(255, 127, 90, 1)',
                  width: 2
                },
              },
            };
            this.earningChartConfig.series[0].areaStyle = {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{        // 1代表上面
                offset: 0,
                color: 'rgba(255, 127, 90, 0.2)'
              }, {
                offset: 1,
                color: 'rgba(255, 127, 90, 0)'
              }]),
            };
          }
          let selfData = [];
          if(res.data.y.length){
            this.statistics.todayProfit = setSufx(res.data.y[res.data.y.length - 1].profitDay);
            for (let i = 0; i < res.data.y.length; i++) {
              selfData.push(res.data.y[i].profitAmount);
              this.profitAmountToday.push(res.data.y[i].profitDay);
            }
          }
          this.earningChartConfig.series[0].data = selfData;

          this.earningChartConfig.xAxis.axisLabel.color = this.themeFontColor;
          this.earningChartConfig.yAxis.axisLabel.color = this.themeFontColor;
          this.$refs.traderchart && this.$refs.traderchart.set();
        })
      },
      getTimeNumber(){
        switch (this.month) {
          case 1:
            return 1;
          case 2:
            return 3;
          case 3:
            return 12;
          case 4:
            return 100;
        }
      }
    }
  };
</script>
<style lang="scss">
    .sybol-tooltip.el-tooltip__popper.is-light{
        border-color: #E6E6E6;
    }
    .sybol-tooltip.el-tooltip__popper.is-light .popper__arrow {
        border-top-color: #E6E6E6;
    }
</style>
<style lang="scss" scoped>
    @import "../../../../../assets/scss/variable";
    .earningsDoubleLineEchart {
        .module-header {
            .title {
                font-size: 16px;
                color: rgba(51, 51, 51, 1);
                font-weight: bold;
            }
        }
        .content {
            padding: 30px;
            padding-top: 15px;
            .statistics {
                left: 0;
                top: 10px;
                .recently {
                    font-size: 12px;
                }
            }
            .statistics,
            .statistics-left,
            .statistics-right {
                display: flex;
                justify-content: flex-start;
                align-items: center;
            }
            .statistics-left {
                margin-right: 30px;
            }
            .first {
                margin-bottom: 10px;
            }
        }
        .chart-outer {
            height: 420px;
        }
        .earning-right {
            height: 380px;
            background: #FAFAFA;
            border-radius: 5px;
            padding: 20px;
            /deep/ .el-progress-bar__outer {
                background-color: #383C5A;
            }
            /deep/ .el-progress-bar {
                padding-right: 0;
            }
            .title {
                font-size: 14px;
                font-weight: bold;
                color: #333333;
                margin-bottom: 20px;
            }
            .momey {
                color: $themeGreen;
                &.on {
                    color: $themeColor;
                }
            }
            .sybol {
                margin-bottom: 30px;
            }
        }
        .no-data-outer {
            height: 100%;
            width: 100%;
            text-align: center;
            line-height: 420px;
        }
    }
</style>
